import { createContext } from "react";

const SelectedFolderContext = createContext(null);

export { SelectedFolderContext };
export default SelectedFolderContext;
